import { RestApi } from "../services/rest-api";
import { YesNo } from "../types/yes-no.type";

export interface ColorModel {
  id?: number;
  color_name: string;
  publish: YesNo;
}

export const fetchColorList = async (authInfo: any) => {
  return await RestApi<Array<ColorModel>>('post', 'colorList', {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const deleteColor = async (id: number, authInfo: any) => {
  return await RestApi<any>('post', 'deleteColor', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

